import { useLanguage } from "../i18n/LanguageContext";
import { useEffect } from "react";
import * as si from "react-icons/si";
import outSystemsLogo from "../components/pictures/logos/outsystems-logo-ring-main.png";
import myFatoorahLogo from "../components/pictures/logos/myFatoorahLogo.png";
import Chartjs from "../components/pictures/logos/Chartjs.png";
import jestLogo from "../components/pictures/logos/jestLogo.png";
import renderLogo from "../components/pictures/logos/renderLogo.jpeg";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import {
  FiActivity,
  FiBarChart2,
  FiCheckCircle,
  FiDatabase,
  FiFileText,
  FiGlobe,
  FiList,
  FiLayers,
  FiMessageCircle,
  FiRefreshCw,
  FiSearch,
  FiTarget,
  FiTool,
} from "react-icons/fi";
import { FaCode } from "react-icons/fa6";

const OutSystemsLogo = () => <img src={outSystemsLogo} alt="" />;
const MyFatoorahLogo = () => <img src={myFatoorahLogo} alt="" />;
const chartjs = () => <img src={Chartjs} alt="" />;
const RenderLogo = () => <img src={renderLogo} alt="" />;
const JestLogo = () => <img src={jestLogo} alt="" />;

// Use the supplied OutSystems artwork alongside the installed brand icons.
const groups = [
  {
    id: "development",
    items: [
      ["JavaScript", si.SiJavascript, "#9b7200"],
      ["TypeScript", si.SiTypescript, "#3178c6"],
      ["Ruby", si.SiRuby, "#b52222"],
      ["Python", si.SiPython, "#3776ab"],
      ["HTML/CSS", FaCode],
      ["React", si.SiReact, "#087e9b"],
      ["Next.js", si.SiNextdotjs],
      ["Ruby on Rails", si.SiRubyonrails, "#b52222"],
      ["StimulusJS", si.SiStimulus, "#ad491c"],
      ["Turbo", si.SiTurbo, "#b52222"],
      ["TanStack", FiLayers],
      ["Tailwind CSS", si.SiTailwindcss, "#087e9b"],
      ["Bootstrap", si.SiBootstrap, "#7952b3"],
    ],
  },
  {
    id: "databases",
    items: [
      ["PostgreSQL", si.SiPostgresql, "#336791"],
      ["MongoDB", si.SiMongodb, "#34813b"],
    ],
  },
  {
    id: "delivery",
    items: [
      ["GitHub", si.SiGithub],
      ["Jira", si.SiJira, "#1868db"],
      ["skills.agile", FiRefreshCw],
      ["Yarn", si.SiYarn, "#237c9b"],
      ["npm", si.SiNpm, "#b52222"],
      ["Swagger", si.SiSwagger, "#527c27"],
      ["Postman", si.SiPostman, "#c94e21"],
      ["Insomnia", si.SiInsomnia, "#6441bf"],
      ["RSpec", FiCheckCircle],
      ["JestJS", JestLogo],
      ["Sentry", si.SiSentry, "#6b4565"],
      ["Code Climate", si.SiCodeclimate],
      ["BetterStack", FiActivity],
    ],
  },
  {
    id: "hosting",
    items: [
      ["DigitalOcean", si.SiDigitalocean, "#1868db"],
      ["Netlify", si.SiNetlify, "#087e80"],
      ["Vercel", si.SiVercel],
      ["Heroku", si.SiHeroku, "#6441bf"],
      ["Render", RenderLogo],
    ],
  },
  {
    id: "integrations",
    items: [
      ["Algolia", si.SiAlgolia, "#4356b8"],
      ["Twilio", si.SiTwilio, "#c5263e"],
      ["Zendesk", si.SiZendesk],
      ["skills.myFatoorah", MyFatoorahLogo],
    ],
  },
  {
    id: "data",
    items: [
      ["skills.cleaning", FiList],
      ["skills.analysis", FiBarChart2],
      ["SQL", FiDatabase],
      ["Pandas", si.SiPandas, "#442c80"],
      ["IBM Cognos", FiBarChart2],
      ["Microsoft Excel", PiMicrosoftExcelLogoFill],
      ["Google Sheets", si.SiGooglesheets],
      ["Chart.js", chartjs],
    ],
  },
  {
    id: "platforms",
    items: [
      ["Shopify", si.SiShopify, "#527c27"],
      ["Squarespace", si.SiSquarespace],
      ["OutSystems", OutSystemsLogo],
    ],
  },
  {
    id: "work",
    items: [
      ["skills.problemSolving", FiTool],
      ["skills.criticalThinking", FiTarget],
      ["skills.adaptability", FiRefreshCw],
      ["skills.documentation", FiFileText],
      ["skills.communication", FiMessageCircle],
      ["skills.prioritization", FiList],
      ["skills.detail", FiSearch],
      ["skills.bilingual", FiGlobe],
    ],
  },
];

const Skills = () => {
  const { t } = useLanguage();
  useEffect(() => {
    const keywords = document.querySelector('meta[name="keywords"]');
    if (keywords)
      keywords.setAttribute(
        "content",
        "Hessah Alhamadi, full-stack developer, Kuwait, skills, JavaScript, TypeScript, Ruby, Python, React, Next.js, Ruby on Rails, PostgreSQL, MongoDB, data analytics",
      );
  }, []);

  return (
    <div id="skills" className="skills">
      <div className="skills-heading">
        <span className="skills-eyebrow">{t("nav.skills")}</span>
        <h1>{t("skills.title")}</h1>
        <p className="skills-introduction">{t("skills.introduction")}</p>
      </div>
      <div className="skills-bento">
        {groups.map(({ id, items }, index) => (
          <section
            className={`skills-card skills-card--${id}`}
            key={id}
            aria-labelledby={`skills-${id}`}
          >
            <span className="skills-card-number" aria-hidden="true">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h2 id={`skills-${id}`}>{t(`skills.category.${id}`)}</h2>
            <ul className="skills-chips">
              {items.map(([label, Icon, color]) => (
                <li className="skill-chip" key={label}>
                  <span className="skill-logo" style={{ color }}>
                    <Icon aria-hidden="true" focusable="false" />
                  </span>
                  <span dir={label.startsWith("skills.") ? undefined : "ltr"}>
                    {t(label)}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Skills;
